import React, { useState } from 'react';
import { ChevronRight, Asterisk } from 'lucide-react';
import { Link } from 'react-router-dom';
import { services } from '../mock';
import Marquee from './Marquee';

export default function Services() {
  const [active, setActive] = useState(services[0].id);
  const current = services.find((s) => s.id === active);

  const renderTab = (s) => {
    const on = s.id === active;
    return (
      <button
        onClick={() => setActive(s.id)}
        className="text-left rounded-2xl px-6 py-4 w-full transition-all duration-300"
        style={{
          backgroundColor: on ? 'var(--service-yellow)' : '#fff',
          border: `1px solid ${on ? 'var(--service-yellow-border)' : 'var(--line)'}`,
          boxShadow: on ? '0 8px 22px -14px rgba(0,0,0,0.25)' : 'none',
        }}
      >
        <span className="block text-[13px] mb-1" style={{ color: 'var(--muted)' }}>Service {s.no}</span>
        <span className="block font-semibold leading-snug" style={{ color: 'var(--forest)' }}>{s.title}</span>
      </button>
    );
  };

  return (
    <section id="services" className="section" style={{ backgroundColor: 'var(--cream-2)' }}>
      <div className="container-x">
        <div className="text-center max-w-[760px] mx-auto reveal">
          <p className="eyebrow mb-2">Our Services</p>
          <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3.1rem)' }}>Seniors stay safe, comfortable &amp; happy at home</h2>
          <p className="mt-5" style={{ color: 'var(--muted)' }}>
            Our acclaimed Senior Home Care in North Dallas helps with daily activities around the
            house, provides meaningful companionship, and handles bathing, dressing, and toileting
            with dignity. Specialized care and Life Care Management are available for more complex needs.
          </p>
          <p className="mt-3 text-sm" style={{ color: 'var(--muted)' }}>
            Tap a service to explore it &mdash; hover or touch to pause.
          </p>
        </div>

        {/* Auto-moving tab marquee (reliable on mobile & desktop) */}
        <div className="mt-10">
          <Marquee
            items={services}
            itemWidth={248}
            gap={16}
            durationSec={44}
            renderItem={(s) => renderTab(s)}
          />
        </div>

        {/* Detail panel: image left, yellow content right */}
        <div className="rounded-[28px] overflow-hidden mt-6 grid md:grid-cols-2" style={{ minHeight: 460 }}>
          <div className="relative min-h-[280px]">
            <img key={current.image} src={current.image} alt={current.title} className="absolute inset-0 w-full h-full object-cover" />
          </div>
          <div className="p-8 lg:p-12 flex flex-col justify-center" style={{ backgroundColor: 'var(--service-yellow)' }}>
            <h3 className="text-3xl" style={{ color: 'var(--forest)' }}>{current.title}</h3>
            <p className="mt-4" style={{ color: '#3A4A38' }}>{current.desc}</p>

            <p className="mt-7 mb-4 font-bold text-[17px]" style={{ color: 'var(--forest)' }}>What&rsquo;s Included:</p>
            <ul className="grid sm:grid-cols-2 gap-y-3.5 gap-x-6">
              {current.included.map((it) => (
                <li key={it} className="flex items-start gap-2.5 text-[15px]">
                  <Asterisk size={18} style={{ color: 'var(--forest)' }} className="mt-0.5 shrink-0" strokeWidth={2.4} />
                  <span className="font-medium" style={{ color: 'var(--forest)' }}>{it}</span>
                </li>
              ))}
            </ul>

            <Link
              to={`/services/${current.id}`}
              className="inline-flex items-center gap-1.5 mt-9 font-bold text-[16px] group"
              style={{ color: 'var(--forest)' }}
            >
              <span className="border-b-2 pb-0.5" style={{ borderColor: 'var(--forest)' }}>Learn more</span>
              <ChevronRight size={18} className="transition-transform duration-200 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
